import * as React from "react";
import { useEffect, useMemo, useState, useRef } from "react";
import EYLogoAndHelpUrl from "../EYLogoAndHelpUrl";
import { currentResource, labels } from "../../util/utils";
import { ExcelHelper } from "../../helpers/ExcelHelper";
import { EntityConfiguration } from "../../configurations/configuration";
import { EntityType, screenToRender, Constants, clientRequestAllStatus } from "../../util/UIConstants";
import styled from "styled-components";
import EngagementSelectLayout from "../common/EngagementSelectLayout";
import SummaryView from "../common/SummaryView";
import _ = require("lodash");
import EntitySelectLayout from "../common/EntitySelectLayout";
import ProgressLoader from "../common/progressLoader";
import BoundSheetAlreadyExistErrorLayout from "../common/BoundSheetExistErrorLayout";
import { validationForExistingInput, parseErrorData } from "../../helpers/common/DataUtilityHelper";
import { EditTaskConfiguration } from "../../configurations/task/EditTaskConfiguration";
import { DocumentConfiguration } from "../../configurations/document/DocumentConfiguration";
import { ItgcConfiguration } from "../../configurations/itgc/ItgcConfiguration";
import { MisstatementConfiguration } from "../../configurations/misstatement/MisstatementConfiguration";
import { controlConfiguration } from "../../configurations/control/controlConfiguration";
import { TimePhaseConfiguration } from "../../configurations/timephase/TimePhaseConfiguration";
import { DeficiencyConfiguration } from "../../configurations/deficiency/DeficiencyConfiguration";
import { AddOSTTaskConfiguration } from "../../configurations/task/AddOstTaskConfiguration";
import { TaskReferenceSheetConfiguration } from "../../configurations/task/TaskReferenceSheetConfiguration";
import { ClientRequestReferenceConfig } from "../../configurations/clientrequest/ClientRequestConfiguration";
import { ClientRequestUIExcelInterface } from "../../services/clientrequest/ClientRequestUIExcelInterface";
//import {documentTemplateJSON} from '../../templates/documenttemplate.json'; // Corrected import statement
const documentJsonTemplate = require("../../templates/documenttemplate.json");
const taskJsonTemplate = require("../../templates/edittasktemplate.json");
const itgcJsonTemplate = require("../../templates/itgctemplate.json");
const misstatementJsonTemplate = require("../../templates/misstatementtemplate.json");
const editclientrequesttemplate = require("../../templates/editclientrequesttemplate.json");
const addostJsontemplate = require("../../templates/addosttasktemplate.json");
const addclientrequesttemplate = require("../../templates/addclientrequesttemplate.json");
const controlJsontemplate = require("../../templates/controltemplate.json");
const timePhaseJsonTemplate = require("../../templates/timephasetemplate.json");
const deficiencyJsonTemplate = require("../../templates/deficiencytemplate.json");
import { TemplateConfiguration } from "../../configurations/template/TemplateConfiguration";
import { TemplateService } from "../../services/template/TemplateService";
import { TemplateTaskUIExcelInterface } from "../../services/task/TemplateTaskUIExcelInterface";
import { TemplateUIExcelInterface } from "../../services/template/TemplateUIExcelInterface";
import { TemplateEditClientRequestConfiguration } from "../../configurations/clientrequest/TemplateClientRequestConfiguration";
import { TemplateAddClientRequestConfiguration } from "../../configurations/clientrequest/TemplateClientRequestConfiguration";
import { EditClientRequestUIExcelInterface } from "../../services/clientrequest/EditClientRequestUIExcelInterface";
import { ClientRequestService } from "../../services/clientrequest/ClientRequestService";
import ClientRequestStatusSelectLayout from "../common/ClientRequestStatusSelectLayout"; //statusSelectLAyout
import { EditClientRequestService } from "../../services/clientrequest/EditClientRequestService";
import { ServiceDataModel } from "../../services/models/Models";
import { ExcelUtilityHelper } from "../../helpers/common/ExcelUtilityHelper";

export interface MainLayoutProps {
  userPreferenceErrorMessage: string;
  userDateTimeFormat: number;
  userLanguage: string;
}

function Main(props: any) {
  const { userPreferenceErrorMessage, userDateTimeFormat, userLanguage } = props;
  const [engagementId, setEngagementId] = useState<string>("");
  const [selectedEntityType, setSelectedEntityType] = useState(EntityType.NotSelected);
  const [loaderStatus, setLoaderStatus] = useState<boolean>(true);
  const [errorMessage, setErrorMessage] = useState<string>(userPreferenceErrorMessage);
  const [boundSheet, setBoundSheet] = useState<string>(null);
  const [stepToRender, setStepToRender] = useState(screenToRender.EngagementSelectLayout);
  const activeSheetId = useRef("");
  const [runOfflineMode, setRunOfflineMode] = useState<boolean>(true);
  const [engagementNameAndId, setEngagementNameAndId] = useState<string>("");
  const [loadDataSummary, setLoadDataSummary] = useState<boolean>(false);
  const [data, setData] = useState(null);
  const [ldcVersioning, setLdcVersioning] = useState({ isLdcUpgraded: false, datacenterversion: "" });
  const [clientRequestStatus, setClientRequestStatus] = useState([clientRequestAllStatus.Draft]);
  const inputObjectParameter = useRef({});
  let templateJson = documentJsonTemplate;

  useEffect(() => {
    settingsLayout();
  }, []);

  const injectService = (entityType) => {
    switch (entityType) {
      case EntityType.Task:
      case EntityType.Document:
      case EntityType.EditITGC:
      case EntityType.EditControl:
      case EntityType.AddOstTask:
      case EntityType.EditMisstatement:
      case EntityType.EditTimePhase:
      case EntityType.EditDeficiency:
        return new TemplateService();
      case EntityType.AddClientRequest:
        return new ClientRequestService();
      case EntityType.EditClientRequest:
        return new EditClientRequestService();
      default:
        return null;
    }
  };

  const injectUiExcelInterface = (entityType) => {
    switch (entityType) {
      case EntityType.Document:
      case EntityType.EditITGC:
      case EntityType.EditControl:
      case EntityType.AddOstTask:
      case EntityType.EditMisstatement:
      case EntityType.EditTimePhase:
      case EntityType.EditDeficiency:
        return new TemplateUIExcelInterface();
      case EntityType.Task:
        return new TemplateTaskUIExcelInterface();
      case EntityType.AddClientRequest:
        return new ClientRequestUIExcelInterface();
      case EntityType.EditClientRequest:
        return new EditClientRequestUIExcelInterface();
      default:
        return null;
    }
  };

  // const isEntityUpdatedWithRequiredVersion = (maximumLDCVersionToUpdateTaskName) => {
  //   return (
  //     parseFloat(ldcVersioning.datacenterversion) >
  //     parseFloat(maximumLDCVersionToUpdateTaskName)
  //   );
  // };

  const getConfigurationForType = (entityType) => {
    let columnsConfig;
    switch (entityType) {
      case EntityType.Document:
        columnsConfig = new DocumentConfiguration();
        break;
      case EntityType.EditITGC:
        columnsConfig = new ItgcConfiguration();
        break;
      case EntityType.EditMisstatement:
        columnsConfig = new MisstatementConfiguration();
        break;
      case EntityType.EditControl:
        columnsConfig = new controlConfiguration();
        break;
      case EntityType.EditTimePhase:
        columnsConfig = new TimePhaseConfiguration();
        break;
      case EntityType.EditDeficiency:
        columnsConfig = new DeficiencyConfiguration();
        break;
      case EntityType.Task:
          columnsConfig = new EditTaskConfiguration();
        break;
      case EntityType.AddClientRequest:
        columnsConfig = new TemplateAddClientRequestConfiguration();
        break;
      case EntityType.EditClientRequest:
        columnsConfig = new TemplateEditClientRequestConfiguration();
        break;
      case EntityType.AddOstTask:
        columnsConfig = new AddOSTTaskConfiguration();
        break;
      default:
        columnsConfig = [];
    }
    return columnsConfig;
  };

  const getReferenceSheetConfigurationForType = (entityType) => {
    let referenceSheetConfig;
    switch (entityType) {
      case EntityType.EditClientRequest:
      case EntityType.AddClientRequest:
        referenceSheetConfig = new ClientRequestReferenceConfig();
        break;
      case EntityType.Task:
        referenceSheetConfig = new TaskReferenceSheetConfiguration();
        break;
      case EntityType.AddOstTask:
        referenceSheetConfig = new TaskReferenceSheetConfiguration();
        break;
      default:
        referenceSheetConfig = [];
    }
    return referenceSheetConfig;
  };

  const getTemplateForEntityType = (entityType) => {
    let templateJson = null;
    switch (entityType) {
      case EntityType.Document:
        templateJson = documentJsonTemplate;
        break;
      case EntityType.EditITGC:
        templateJson = itgcJsonTemplate;
        break;
      case EntityType.EditMisstatement:
        templateJson = misstatementJsonTemplate;
        break;
      case EntityType.EditControl:
        templateJson = controlJsontemplate;
        break;
      case EntityType.EditTimePhase:
        templateJson = timePhaseJsonTemplate;
        break;
      case EntityType.EditDeficiency:
        templateJson = deficiencyJsonTemplate;
        break;
      case EntityType.Task:
          templateJson = taskJsonTemplate;
        break;
      case EntityType.AddOstTask:
        templateJson = addostJsontemplate;
        break;
      case EntityType.AddClientRequest:
        templateJson = addclientrequesttemplate;
        break;
      case EntityType.EditClientRequest:
        templateJson = editclientrequesttemplate;
        break;
    }
    return templateJson;
  };

  const getSettingsData = () => {
    let settings = {
      userLanguage: userLanguage,
      sheetName: boundSheet,
      sheetId: activeSheetId.current,
      ldcVersionWhenEngagementLoads: ldcVersioning.datacenterversion,
      entitySelected: currentResource.ButtonOptions.find((b) => b.id == selectedEntityType).label,
    };
    return settings;
  };

  const getConfiguration = (entityType: EntityType) => {
    let templateJson = getTemplateForEntityType(entityType);
    let entityService = injectService(entityType);
    let entityUIExcelService = injectUiExcelInterface(entityType);
    let referenceSheetConfig = getReferenceSheetConfigurationForType(entityType);
    // let templateJsonData = templateService.readJSONTemplateAsync(templatePath, entityType, null);
    let entityBasedConfiguration = getConfigurationForType(entityType);
    let templateConfig: TemplateConfiguration = new TemplateConfiguration(templateJson, entityBasedConfiguration);
    let entityConfigration: EntityConfiguration = new EntityConfiguration(
      templateConfig.columns,
      referenceSheetConfig.columns,
      engagementId,
      entityType,
      templateConfig
    );
    entityConfigration.apiInterface = entityService;
    entityConfigration.uiExcelInterface = entityUIExcelService;
    entityConfigration.settings = getSettingsData();
    entityConfigration.formatDependentAPICallData = referenceSheetConfig?.formatDependentAPICallData;
    return entityConfigration;
  };

  const handlerForTheNavigation = async (activeSheetsId: string, boundsheet: string) => {
    if (boundsheet != null) {
      if (activeSheetsId == activeSheetId.current) {
        setLoadDataSummary(true);
        setStepToRender(screenToRender.SummaryView);
        setBoundSheet(boundsheet);
        setLoaderStatus(false);
      } else {
        setStepToRender(screenToRender.InputSheetAlreadyExistsLayout);
        setLoaderStatus(false);
        setBoundSheet(boundsheet);
      }
    } else {
      setSelectedEntityType(EntityType.NotSelected);
      setStepToRender(screenToRender.EngagementSelectLayout);
      setLoaderStatus(false);
    }
  };

  const requestTableDataCellsOnSheetActivate = async (event: Excel.WorksheetActivatedEventArgs) => {
    setEngagementId("");
    setEngagementNameAndId("");
    setClientRequestStatus([clientRequestAllStatus.Draft]);
    setLoadDataSummary(true);
    setRunOfflineMode(false);
    setLoaderStatus(true);
    let { boundsheet, engagementId, selectedEntityType, activeSheetsId, error } = await validationForExistingInput();
    if (error) {
      setErrorMessage(error);
    }
    resetEnableEvent(boundsheet == null ? false : true);
    setEngagementId(engagementId);
    activeSheetId.current = activeSheetsId;
    setSelectedEntityType(selectedEntityType);
    let currentActiveSheetId: string = "";
    if (!error) {
      await Excel.run(async (context) => {
        let currentSheet: Excel.Worksheet;
        currentSheet = context.workbook.worksheets.getActiveWorksheet();
        // context.workbook.worksheets.onActivated.add(this.requestTableDataCellsOnSheetActivate);
        currentSheet.load("id");
        await ExcelHelper.tryCatchContextSync(context, `load the sheet name to text box`);
        currentActiveSheetId = currentSheet.id;
      });
    }

    await handlerForTheNavigation(currentActiveSheetId, boundsheet);
  };

  const getEngagementIdFromWorksheet = async (eventStatus: boolean) => {
    let activeSheetId: string = "";
    await Excel.run(async (context) => {
      let currentSheet: Excel.Worksheet;
      currentSheet = context.workbook.worksheets.getActiveWorksheet();
      await toAddOnSheetChangesEvent();
      await resetEnableEvent(eventStatus);
      currentSheet.load("name");
      currentSheet.load("id");
      await ExcelHelper.tryCatchContextSync(context, `load the sheet name to text box`);
      activeSheetId = currentSheet.id;
    });
    return activeSheetId;
  };

  //Adding event to detect the sheet change and disabling event for the first time.
  //We need event to listen only when bound sheet exist.
  const toAddOnSheetChangesEvent = async () => {
    await Excel.run(async (context) => {
      context.workbook.worksheets.onActivated.add(requestTableDataCellsOnSheetActivate);
      await context.sync();
      context.runtime.enableEvents = false;
      await context.sync();
    });
  };

  //This method decides whether to enable or disable the events based on the bound sheet exist or not that we pass as props eventStatus.
  //eventStatus will be true if bound sheet exist and false if bound sheet does not exist.
  const resetEnableEvent = async (eventStatus: boolean) => {
    await Excel.run(async (context) => {
      context.runtime.enableEvents = eventStatus;
      await context.sync();
    });
  };

  const settingsLayout = async () => {
    //let boundsheet = await validationForExistingInput();
    let { boundsheet, engagementId, selectedEntityType, activeSheetsId, error } = await validationForExistingInput(setLdcVersioning);
    if (error) {
      setErrorMessage(error);
    }
    setEngagementId(engagementId);
    activeSheetId.current = activeSheetsId;
    setSelectedEntityType(selectedEntityType);
    let eventStatus = boundsheet == null ? false : true;
    let currentActiveSheetId: string = !error ? await getEngagementIdFromWorksheet(eventStatus) : "";
    await handlerForTheNavigation(currentActiveSheetId, boundsheet);
  };

  const onEntityTypeIdChange = () => {
    //This condition is there as we have one extra screen for edit client request
    if (selectedEntityType != EntityType.EditClientRequest) {
      onDataLoadClick();
    } else {
      setStepToRender(screenToRender.ClientRequestStatusSelectLayout);
    }
  };

  const generateErrorMessage = (response) => {
    // we can some specfic validation error
    return labels.engagementIdNotFound;
    // create error based on validation response from api such as precondition failed, bad request
  };

  const onDataLoadClick = async () => {
    let { boundsheet } = await validationForExistingInput();

    if (boundsheet != null) {
      setErrorMessage(labels.boundSheetAlreadyPopulated);
      return;
    }

    setLoaderStatus(true);

    let configuration = getConfiguration(selectedEntityType);

    let sheetWithSameNameExist: string = await ExcelUtilityHelper.checkForExistingSheet(engagementId);

    if (!sheetWithSameNameExist) {
      let dataModel: ServiceDataModel = await configuration.apiInterface.downloadDataAsync(
        engagementId,
        configuration,
        inputObjectParameter.current,
        ldcVersioning
      );
      let errorMessage = parseErrorData(dataModel, generateErrorMessage);
      if (!errorMessage) {
        const errorMessage = await ExcelUtilityHelper.addNewInputSheet(setBoundSheet, activeSheetId, engagementId);
        if (!errorMessage) {
          setLoaderStatus(false);
          setData(dataModel);
          setLoadDataSummary(false);
          setStepToRender(screenToRender.SummaryView);
        } else {
          setLoaderStatus(false);
          setErrorMessage(errorMessage ?? labels.generalError);
        }
      } else {
        setLoaderStatus(false);
        setErrorMessage(errorMessage);
      }
    } else {
      setLoaderStatus(false);
      setErrorMessage(labels.sheetWithSameNameExist.replace("{0}", sheetWithSameNameExist));
    }
  };

  const resetErrorMessageCallback = () => {
    setErrorMessage("");
  };

  // Render method
  const renderContent = () => {
    if (loaderStatus) {
      return (
        <StyledMainSection className="main-wrap spinner-main">
          <section className="body-wrap">
            <EYLogoAndHelpUrl />
            <ProgressLoader show variant="default" />
            {/* <Spinner className="spinner-wrap" size={SpinnerSize.medium} label={labels.loadingContent}/> */}
          </section>
        </StyledMainSection>
      );
    }

    if (stepToRender == screenToRender.InputSheetAlreadyExistsLayout) {
      return <BoundSheetAlreadyExistErrorLayout />;
    }

    if (stepToRender == screenToRender.SummaryView) {
      return (
        <SummaryView
          engagementId={engagementId}
          loadSummary={loadDataSummary}
          activeSheetName={boundSheet}
          configuration={getConfiguration(selectedEntityType)}
          activeSheetId={activeSheetId.current}
          dataModel={data}
          engagementSelected={engagementNameAndId}
          userDateTimeFormat={userDateTimeFormat}
          runOfflineMode={runOfflineMode}
          userLanguage={userLanguage}
          ldcVersioning={ldcVersioning}
        />
      );
    }
    if (stepToRender == screenToRender.EntitySelectLayout) {
      //return <StyledMainSection className="main-wrap">{getEntityLayout()}</StyledMainSection>;
      return (
        <EntitySelectLayout
          onEntityTypeIdChange={onEntityTypeIdChange}
          setSelectedEntityType={setSelectedEntityType}
          errorMessage={errorMessage}
          resetErrorMessage={resetErrorMessageCallback}
          setStepToRender={setStepToRender}
          ldcVersioning={ldcVersioning}
          selectedEntityType={selectedEntityType}
        />
      );
    }

    if (stepToRender == screenToRender.ClientRequestStatusSelectLayout) {
      return (
        <section>
          <ClientRequestStatusSelectLayout
            inputObjectParameter={inputObjectParameter}
            setStepToRender={setStepToRender}
            onDataLoadClickMethod={onDataLoadClick}
            errorMessage={errorMessage}
            resetErrorMessage={resetErrorMessageCallback}
            clientRequestStatus={clientRequestStatus}
            setClientRequestStatus={setClientRequestStatus}
          />
        </section>
      );
    }

    return (
      <section>
        <EngagementSelectLayout
          setStepToRender={setStepToRender}
          setEngagementIdToRender={setEngagementId}
          engagementNameAndId={engagementNameAndId}
          setEngagementNameAndId={setEngagementNameAndId}
          toastErrorMessage={errorMessage}
          resetErrorMessage={resetErrorMessageCallback}
          setLdcVersioning={setLdcVersioning}
          engagementId={engagementId}
        />
      </section>
    );
  };
  return renderContent();
}

export default Main;

const StyledMainSection = styled.section`
  height: 100%;
  &.spinner-main {
    background-color: var(--neutrals-900);
  }
  .body-wrap {
    position: relative;
    flex-flow: column;
    display: flex;
    background-color: var(--neutrals-50);
    padding: var(--px-12) var(--px-24);
    height: 100vh;
    overflow: auto;
    .breadcrumb-wrap {
      display: flex;
      align-items: center;
      a {
        color: var(--brand-500) !important;
        text-decoration: none;
      }
    }
    .informational-text {
      font-size: var(--px-12);
      font-weight: 300;
      margin: 0;
      color: var(--neutrals-900);
    }
    .submit-text {
      font-weight: 400;
    }

    .informational-text2 {
      margin-top: var(--px-15);
      color: var(--neutrals-900);
    }

    .btns-wrap {
      margin: var(--px-12) 0 var(--px-10) 0;
    }
    .btn {
      width: 100%;
      margin-bottom: var(--px-12);
      margin-top: var(--px-12);

      &.secondary-btn {
        width: 30%;
        &:hover {
          cursor: pointer;
        }
      }
      &:last-child {
        margin-top: var(--px-12);
        margin-bottom: 0;
      }
    }

    .note-text-wrap {
      display: flex;
      align-items: center;
      line-height: var(--px-13);
      font-size: var(--px-12);
      svg {
        fill: var(--red-300);
        width: var(--px-16);
        height: var(--px-16);
        margin-right: var(--px-4);
      }
    }
  }
`;
